"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoveltyLabel = exports.LabelWrapper = exports.NoveltyWrapper = void 0;
const app_1 = require("@obvio/app");
exports.NoveltyWrapper = app_1.styled.div `
  position: relative;
  background-color: #ffffff;
`;
exports.LabelWrapper = app_1.styled.div `
  position: absolute;
  bottom: 15%;
  right: 10%;
  text-align: center;
  padding-left: ${(theme) => theme.spacing.medium};
  @media ${app_1.notDesktop} {
    bottom: 5%;
    right: 5%;
    position: static;
    padding: ${(theme) => theme.spacing.small};
  }
`;
exports.NoveltyLabel = (0, app_1.styled)(app_1.Text) `
  font-size: 3rem;
  margin-bottom: ${(theme) => theme.spacing.small};
  line-height: 100%;
  @media ${app_1.notDesktop} {
    font-size: 1.5rem;
    margin-bottom: ${(theme) => theme.spacing.small};
  }
`;
